import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { rGetSubDomainList } from "../../redux/DataSets/action";
import useDomainList from "../../utils/CustomHooks/useDomainList";
import SubDomainListItem from "./components/SubDomainListItem";
import CreateSubDomain from "./modal/CreateSubDomain";
import PaginationComponent from "../../components/PaginationComponent";
import "./subdomain.css";
import withRoleBased from "../../utils/Functions/withRoleBased";
import useSubDomainList from "../../utils/CustomHooks/useSubDomainList";
import SubDomainModal from "./modal/SubDomainModal";
import { sortArray } from "../../utils/Functions/filter";

function SubDomain({ access }) {
  const [isOpen, setIsOpen] = useState(false);
  const [count, setCount] = useState(0);
  const { domainList, getDomainList } = useDomainList("");
  const { subDomains, loading, getSubDomains } = useSubDomainList(true);
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(0);
  const [search, setSearch] = useState("");
  const [isSearching, setIsSearch] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const pageCount = Math.ceil(subDomains.length / pageSize);
  useEffect(() => {
    let req = {};
    if (search) req.sub_domain_name = search;
    getSubDomains(req, true);
    dispatch(rGetSubDomainList());
  }, [count]);
  const handleClick = (event, index) => {
    event.preventDefault();
    setCurrentPage(index);
  };
  useEffect(() => {
    getDomainList();
    dispatch(rGetSubDomainList());
    return () => dispatch(rGetSubDomainList());
  }, []);
  const onSearch = () => {
    setCount((x) => x + 1);
    setCurrentPage(0)
    setIsSearch(search ? true : false);
  };
  return (
    <main className="page-content">
      <div className="container-fluid">
        <div className="row m-0 w-100">
          <div className="col-md-6 mb-3">
            <h5 className="page-title"> Sub Domain </h5>
          </div>
          <div className="col-md-6  mb-3 d-flex justify-content-md-end">
            {access.canCreate && (
              <button
                type="button"
                className="btn btn-outline-success "
                onClick={() => setIsOpen(true)}
              >
                Create Sub Domain
              </button>
            )}
          </div>

          <div className="col-md-4">
            <div className="search" style={{ margin: "16px 0px 32px" }}>
              <input
                type="text"
                className="form-control"
                placeholder="Search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && onSearch()}
              />
              {!isSearching ? (
                <button onClick={onSearch}>
                  <i className="fa fa-search" />
                </button>
              ) : (
                <button
                  onClick={() => {
                    setSearch("");
                    setIsSearch(false);
                    setCount((x) => x + 1);
                  }}
                >
                  <i className="fa fa-times" />
                </button>
              )}
            </div>
          </div>
          <div className="col-md-12">
            <div className="table-responsive">
              <table className="table table-borderless ">
                <thead>
                  <tr>
                    <td className="col-sm-2">Name</td>
                    <td className={access.canEdit ? "col-sm-4" : "col-sm-6"}>
                      Description{" "}
                    </td>
                    <td className="col-sm-2">Domain </td>
                    <td className="col-sm-2">Status</td>
                    {access.canEdit && <td className="col-sm-2">Action</td>}
                  </tr>
                </thead>
                <tbody>
                  {!loading && subDomains && subDomains.length > 0 ? (
                    sortArray(subDomains)
                      .slice(
                        currentPage * pageSize,
                        (currentPage + 1) * pageSize
                      )
                      .map((x, i) => (
                        <SubDomainListItem
                          item={x}
                          index={i}
                          key={i}
                          refresh={() => setCount((x) => x + 1)}
                          domainList={domainList}
                          access={access}
                        />
                      ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center">
                        <span className="font-weight-bold">
                          {loading ? "Loading..." : "Oops! No Data Found"}
                        </span>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {subDomains.length > 0 && pageCount != 1 && (
          <PaginationComponent
            handleClick={handleClick}
            currentPage={currentPage}
            pageCount={pageCount}
          />
        )}
      </div>
      {isOpen && (
        <SubDomainModal
          isOpen={isOpen}
          setOpen={() => setIsOpen(false)}
          refresh={() => setCount((x) => x + 1)}
          domainList={domainList}
          isFirst={true}
        />
      )}
    </main>
  );
}
export default withRoleBased(SubDomain, "subDomain");
